(function () {
  'use strict';

  // ---- funções puras (contrato do plano, C1: mesma validação do servidor) ----
  function soDigitos(v) { return String(v || '').replace(/\D/g, ''); }
  function normalizarWhatsapp(v) {
    var d = soDigitos(v);
    if (d.length === 13 && d.slice(0, 2) === '55') d = d.slice(2);
    return /^[1-9][1-9]9\d{8}$/.test(d) ? '+55' + d : null;
  }
  function emailValido(v) { var e = String(v || '').trim().toLowerCase(); return e.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e) ? e : null; }
  function nomeValido(v) { var n = String(v || '').replace(/\s+/g, ' ').trim(); return n.length >= 2 && n.length <= 80 && /[A-Za-zÀ-ÿ]/.test(n) ? n : null; }
  function excluidoPorUtm(search, lista) {
    var q = String(search || '').toLowerCase();
    return lista.some(function (x) { return x && q.indexOf('utm_source=' + x) !== -1; });
  }
  // Anúncio, pela régua da plataforma de influência (ei-beleza-influencers, lib/shopify/origem.ts:
  // MEDIUM_PAGO, CLIQUE_PAGO e ANUNCIO_SEM_UTM, medidas em pedidos reais da BB). Lá os ids só valem
  // sem UTM porque a régua não pode reclassificar venda; aqui qualquer sinal basta. `fbclid` fica
  // de fora: o Instagram carimba em todo clique, inclusive no link orgânico da influenciadora.
  var MEDIUM_PAGO = ['cpc', 'paid', 'ppc', 'display', 'paid_social', 'paidsocial'];
  var ID_DE_ANUNCIO = ['gclid', 'gad_source', 'gbraid', 'wbraid', 'ad_id', 'adset_id', 'ttclid', 'msclkid'];
  function deAnuncio(search) {
    var p = new URLSearchParams(String(search || '').toLowerCase());
    return MEDIUM_PAGO.indexOf(p.get('utm_medium')) !== -1 || ID_DE_ANUNCIO.some(function (c) { return p.has(c); });
  }
  // Link de cupom (/discount/<código>, o formato do link da influenciadora): a Shopify grava o
  // código no cookie discount_code, legível pelo JS. Converter aqui trocaria esse cupom pelo nosso.
  function comOutroCupom(cupom) {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    var codigo;
    try { codigo = decodeURIComponent(m[1]); } catch (e) { codigo = m[1]; }
    return codigo !== '' && codigo.toUpperCase() !== String(cupom || '').toUpperCase();
  }

  var CHAVES = {
    off: 'bb_popup_off',
    estado: 'bb_popup_estado',
    widgetFechado: 'bb_popup_widget_fechado',
    barraFechada: 'bb_popup_barra_fechada',
    pendentes: 'bb_popup_pendentes',
    excluido: 'bb_popup_excluido',
    utm: 'bb_popup_utm'
  };

  function lerConfig() {
    var el = document.getElementById('PopupLeadConfig');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function lerLS(chave) { try { return localStorage.getItem(chave); } catch (e) { return null; } }
  function gravarLS(chave, valor) { try { localStorage.setItem(chave, valor); } catch (e) {} }
  function lerSS(chave) { try { return sessionStorage.getItem(chave); } catch (e) { return null; } }
  function gravarSS(chave, valor) { try { sessionStorage.setItem(chave, valor); } catch (e) {} }

  function lerEstado() {
    var bruto = lerLS(CHAVES.estado);
    if (!bruto) return null;
    try { return JSON.parse(bruto); } catch (e) { return null; }
  }
  function gravarEstado(estado, nome) {
    var atual = lerEstado();
    var registro = { estado: estado, nome: nome != null ? nome : ((atual && atual.nome) || ''), em: Date.now() };
    gravarLS(CHAVES.estado, JSON.stringify(registro));
  }

  function lerFila() {
    try { return JSON.parse(lerLS(CHAVES.pendentes) || '[]'); } catch (e) { return []; }
  }
  function enfileirar(corpo) {
    var fila = lerFila();
    fila.push(corpo);
    if (fila.length > 5) fila = fila.slice(fila.length - 5);
    gravarLS(CHAVES.pendentes, JSON.stringify(fila));
  }

  function emitir(evento, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: evento };
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k]; } }
    window.dataLayer.push(payload);
  }

  var cfg = lerConfig();
  if (!cfg) return;

  var overlay = document.getElementById('PopupLeadOverlay');
  var widgetEl = document.getElementById('PopupLeadWidget');
  var barraEl = document.getElementById('PopupLeadBarra');
  if (!overlay || !widgetEl || !barraEl) return;

  var dialogEl = overlay.querySelector('.pl-dialog');
  var formEl = overlay.querySelector('[data-pl-form]');
  var premioEl = overlay.querySelector('[data-premio]');
  var campoEmail = document.getElementById('PopupLeadEmail');
  var campoWhatsapp = document.getElementById('PopupLeadWhatsapp');
  var campoNome = document.getElementById('PopupLeadNome');
  var campoHp = overlay.querySelector('[data-pl-hp]');
  var passosEls = Array.prototype.slice.call(overlay.querySelectorAll('.pl-passo'));
  var botaoAvancar = overlay.querySelector('[data-pl-avancar]');
  var botaoRecusar = overlay.querySelector('[data-pl-recusar]');
  var botaoFechar = overlay.querySelector('[data-pl-fechar]');
  var premioTitulo = overlay.querySelector('[data-pl-premio-titulo]');
  var premioTexto = overlay.querySelector('[data-pl-premio-texto]');
  var premioCupom = overlay.querySelector('[data-pl-cupom]');
  var botaoCopiar = overlay.querySelector('[data-pl-copiar]');
  var botaoContinuarComprando = overlay.querySelector('[data-pl-continuar]');
  var widgetAbrir = widgetEl.querySelector('[data-pl-widget-abrir]');
  var widgetFechar = widgetEl.querySelector('[data-pl-widget-fechar]');
  var barraTexto = barraEl.querySelector('[data-pl-barra-texto]');
  var barraCupom = barraEl.querySelector('[data-pl-barra-cupom]');
  var barraCopiar = barraEl.querySelector('[data-pl-barra-copiar]');
  var barraFechar = barraEl.querySelector('[data-pl-barra-fechar]');

  var passoAtual = 1;

  function trocarImagens() {
    // Só as do pop-up: apps que injetam página (Zeno, avaliações) também usam data-src.
    Array.prototype.forEach.call(overlay.querySelectorAll('[data-src]'), function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }

  function limparErro(n) {
    var p = overlay.querySelector('[data-passo="' + n + '"] [data-pl-erro]');
    if (p) { p.hidden = true; p.textContent = ''; }
  }
  function mostrarErro(n, texto) {
    var p = overlay.querySelector('[data-passo="' + n + '"] [data-pl-erro]');
    if (p) { p.textContent = texto; p.hidden = false; }
  }

  function irParaPasso(n) {
    passoAtual = n;
    passosEls.forEach(function (el) { el.hidden = Number(el.dataset.passo) !== n; });
    botaoAvancar.textContent = n === 3 ? cfg.textos.botao_final : cfg.textos.botao_continuar;
    var campo = overlay.querySelector('[data-passo="' + n + '"] .pl-input');
    if (campo) campo.focus();
    if (n === 2 || n === 3) emitir('bb_popup_step', { step: n });
  }

  function elementosFocaveis() {
    // offsetParent é null para elemento escondido (hidden) ou dentro de ancestral escondido --
    // basta isso para restringir ao passo/tela (form ou prêmio) visível no momento.
    return Array.prototype.slice
      .call(dialogEl.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function aoTeclar(e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') { fechar(); return; }
    if (e.key !== 'Tab') return;
    var focaveis = elementosFocaveis();
    if (!focaveis.length) return;
    var primeiro = focaveis[0];
    var ultimo = focaveis[focaveis.length - 1];
    if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
  }
  document.addEventListener('keydown', aoTeclar);

  function abrir() {
    // Toda abertura reinicia o relógio do "reabrir em N dias" (estado.em).
    var estado = lerEstado();
    if (!estado || estado.estado !== 'convertido') gravarEstado('visto', estado ? estado.nome : null);
    widgetEl.hidden = true;
    trocarImagens();
    overlay.hidden = false;
    irParaPasso(1);
    emitir('bb_popup_view');
  }

  function fechar() {
    var estado = lerEstado();
    overlay.hidden = true;
    if (estado && estado.estado === 'convertido') return;
    gravarEstado('fechado', estado ? estado.nome : null);
    if (cfg.widget_ativo && lerSS(CHAVES.widgetFechado) !== '1') mostrarWidget();
    emitir('bb_popup_dismiss');
  }

  function mostrarWidget() { widgetEl.hidden = false; }

  function mostrarBarra(estado) {
    var primeiroNome = ((estado && estado.nome) || '').split(' ')[0];
    barraTexto.textContent = cfg.textos.barra.replace('{primeiro_nome}', primeiroNome).replace('{premio}', cfg.premio);
    barraCupom.textContent = cfg.cupom;
    document.body.insertBefore(barraEl, document.body.firstChild); // topo da página (ver .pl-barra no CSS)
    barraEl.hidden = false;
  }

  function copiar(botao, texto, textoOriginal, textoCopiado) {
    function marcado() {
      botao.textContent = textoCopiado;
      window.setTimeout(function () { botao.textContent = textoOriginal; }, 2000);
    }
    function comFallback() {
      var ta = document.createElement('textarea');
      ta.value = texto;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(texto).then(marcado, function () { comFallback(); marcado(); });
    } else {
      comFallback();
      marcado();
    }
  }

  function lerUtm() {
    var raw = lerSS(CHAVES.utm);
    var vazio = { source: null, medium: null, campaign: null, content: null, term: null };
    if (!raw) return vazio;
    try {
      var u = JSON.parse(raw);
      return { source: u.source || null, medium: u.medium || null, campaign: u.campaign || null, content: u.content || null, term: u.term || null };
    } catch (e) { return vazio; }
  }
  function capturarUtm() {
    if (lerSS(CHAVES.utm)) return;
    var params = new URLSearchParams(location.search);
    var chaves = ['source', 'medium', 'campaign', 'content', 'term'];
    var achou = false;
    var utm = {};
    chaves.forEach(function (k) {
      var v = params.get('utm_' + k);
      if (v) achou = true;
      utm[k] = v || null;
    });
    if (achou) gravarSS(CHAVES.utm, JSON.stringify(utm));
  }

  function enviarConexao(corpo) {
    var controlador = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timeoutId = controlador && window.setTimeout(function () { controlador.abort(); }, 8000);
    fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corpo),
      keepalive: true,
      credentials: 'omit',
      signal: controlador ? controlador.signal : undefined
    }).then(function (r) {
      if (timeoutId) window.clearTimeout(timeoutId);
      if (r.status >= 500 || r.status === 429) enfileirar(corpo);
    }).catch(function () {
      if (timeoutId) window.clearTimeout(timeoutId);
      enfileirar(corpo);
    });
  }

  function reenviarPendentes() {
    var fila = lerFila();
    if (!fila.length) return;
    var restante = [];
    var tarefas = fila.map(function (corpo) {
      return fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(corpo),
        keepalive: true,
        credentials: 'omit'
      }).then(function (r) {
        if (r.status >= 500 || r.status === 429) restante.push(corpo);
      }).catch(function () {
        restante.push(corpo);
      });
    });
    // Tira da fila ATUAL só o que foi entregue: um envio que falhar enquanto este reenvio
    // corre entra na fila e não pode ser apagado por uma gravação com a lista antiga.
    Promise.all(tarefas).then(function () {
      var entregues = fila.filter(function (c) { return restante.indexOf(c) === -1; }).map(function (c) { return JSON.stringify(c); });
      var atual = lerFila().filter(function (c) { return entregues.indexOf(JSON.stringify(c)) === -1; });
      gravarLS(CHAVES.pendentes, JSON.stringify(atual));
    });
  }

  function enviar(nome) {
    var corpo = {
      email: emailValido(campoEmail.value),
      whatsapp: normalizarWhatsapp(campoWhatsapp.value),
      nome: nome,
      pagina: location.pathname,
      utm: lerUtm(),
      origem: 'popup-bb',
      hp: campoHp.value || ''
    };
    gravarEstado('convertido', nome);
    formEl.hidden = true;
    dialogEl.querySelector('.pl-titulo').hidden = true;
    dialogEl.querySelector('.pl-subtitulo').hidden = true;
    premioTitulo.textContent = cfg.textos.premio_titulo.replace('{nome}', nome);
    premioTexto.textContent = cfg.textos.premio_texto.replace('{premio}', cfg.premio);
    premioCupom.textContent = cfg.cupom;
    premioEl.hidden = false;
    emitir('generate_lead', { method: 'popup-bb' });
    enviarConexao(corpo);
    fetch('/discount/' + encodeURIComponent(cfg.cupom), { credentials: 'same-origin' }).catch(function () {});
  }

  // ---- eventos ----
  botaoAvancar.addEventListener('click', function () {
    if (passoAtual === 1) {
      var email = emailValido(campoEmail.value);
      if (!email) return mostrarErro(1, cfg.textos.erro_email);
      limparErro(1);
      irParaPasso(2);
    } else if (passoAtual === 2) {
      var wpp = normalizarWhatsapp(campoWhatsapp.value);
      if (!wpp) return mostrarErro(2, cfg.textos.erro_whatsapp);
      limparErro(2);
      irParaPasso(3);
    } else {
      var nome = nomeValido(campoNome.value);
      if (!nome) return mostrarErro(3, cfg.textos.erro_nome);
      limparErro(3);
      enviar(nome);
    }
  });

  campoWhatsapp.addEventListener('input', function (e) {
    var d = soDigitos(e.target.value);
    if (d.length > 11 && d.slice(0, 2) === '55') d = d.slice(2);
    d = d.slice(0, 11);
    var partes = d.match(/^(\d{0,2})(\d{0,5})(\d{0,4})$/) || [];
    e.target.value = !partes[2] ? (partes[1] || '') : '(' + partes[1] + ') ' + partes[2] + (partes[3] ? '-' + partes[3] : '');
  });

  botaoFechar.addEventListener('click', fechar);
  botaoRecusar.addEventListener('click', fechar);
  botaoContinuarComprando.addEventListener('click', fechar);
  botaoCopiar.addEventListener('click', function () { copiar(botaoCopiar, cfg.cupom, cfg.textos.copiar, cfg.textos.copiado); });

  widgetAbrir.addEventListener('click', function () {
    widgetEl.hidden = true;
    abrir();
  });
  widgetFechar.addEventListener('click', function (e) {
    e.stopPropagation();
    gravarSS(CHAVES.widgetFechado, '1'); // só nesta visita: o botão volta na próxima
    widgetEl.hidden = true;
  });

  barraCopiar.addEventListener('click', function () { copiar(barraCopiar, cfg.cupom, cfg.textos.copiar, cfg.textos.copiado); });
  barraFechar.addEventListener('click', function () {
    gravarLS(CHAVES.barraFechada, '1');
    barraEl.hidden = true;
  });

  function armarRolagem() {
    var lida = false;
    function calcular() {
      lida = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var fracao = (window.scrollY || window.pageYOffset || 0) / max;
      if (fracao * 100 >= cfg.gatilho) {
        window.removeEventListener('scroll', onScroll);
        abrir();
      }
    }
    function onScroll() {
      if (lida) return;
      lida = true;
      window.requestAnimationFrame(calcular);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- modo design: só liga/desliga por seleção da seção, sem tocar em armazenamento ----
  function initDesignMode() {
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === overlay.dataset.sectionId) {
        trocarImagens();
        overlay.hidden = false;
        irParaPasso(1);
      }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === overlay.dataset.sectionId) overlay.hidden = true;
    });
  }

  // ---- inicialização (ordem do plano) ----
  if (lerLS(CHAVES.off) === '1') return;

  if (window.Shopify && window.Shopify.designMode) {
    initDesignMode();
    return;
  }

  capturarUtm();
  if (excluidoPorUtm(location.search, cfg.utms_excluidas) || deAnuncio(location.search) || comOutroCupom(cfg.cupom)) {
    gravarSS(CHAVES.excluido, '1');
  }
  reenviarPendentes();

  var estadoInicial = lerEstado();
  if (lerSS(CHAVES.excluido) === '1') {
    // sessão inteira excluída (influenciadora, anúncio ou outro cupom): nada aparece, nem a barra
  } else if (estadoInicial && estadoInicial.estado === 'convertido') {
    if (cfg.barra_ativa && lerLS(CHAVES.barraFechada) !== '1') mostrarBarra(estadoInicial);
  } else {
    // Botão desde o topo; o pop-up abre na rolagem na 1ª vez e de novo a cada N dias sem cadastro.
    if (cfg.widget_ativo && lerSS(CHAVES.widgetFechado) !== '1') mostrarWidget();
    var dias = Number(cfg.dias_reabrir) || 1;
    if (!estadoInicial || Date.now() - (Number(estadoInicial.em) || 0) >= dias * 864e5) armarRolagem();
  }
})();
